<div class="item">
  <tui-input class="item__title" [(ngModel)]="value" [pseudoInvalid]="invalid" tuiTextfieldSize="s">
    {{ 'components.contactsDirectory.fields.name' | translate }}
  </tui-input>

  <div class="item__buttons">
    <button
      tuiIconButton
      cdkDragHandle
      type="button"
      appearance="icon"
      size="s"
      [iconStart]="'@tui.grip-vertical'"
    ></button>
  </div>
</div>
